export default __webpack_public_path__ + "static/media/questions-slideout.0cbad440.jpg";